import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {AccessRights, PARTS} from "../../schemas/accessRightsModel";
import {getFilteredFeatures} from "./featuresFunctions";
import FeaturesSetupVirtualizedGrid from "./FeaturesSetupVirtualizedGrid";


const FeaturesSetupList = (props) => {

  const {canEdit, featuresList, featuresListReceived, setCurrentScroll} = props;

  // if (!featuresListReceived || !fabricatorSubscriptionsReceived) {
  if (!featuresListReceived) {
    return (
      <div className="fs-list fs-list--loading">
        <div className="ui-loader"/>
      </div>
    )
  }

  if (!canEdit) {
    return <p className={"text-center"}>Check editing features permission</p>
  }

  return <FeaturesSetupVirtualizedGrid featuresList={featuresList} setCurrentScroll={setCurrentScroll}/>
};

FeaturesSetupList.propTypes = {
  setCurrentScroll: PropTypes.func
}

const mapStateToProps = (store) => {

  const {featuresListReceived} = store.featuresSetupState;
  const featuresList = getFilteredFeatures(store);
  const AR = AccessRights.get(store);
  const canEdit = AR.isSiteAdmin(false) || AR.v(PARTS.FAB_CREATE_EDIT_FEATURE);

  return {
    canEdit,
    featuresList,
    featuresListReceived,
  };
};

export default connect(mapStateToProps)(FeaturesSetupList)
